const STORAGE_KEY = 'agent-builder:test-sessions';

/** How a conversation started from the builder asks the API to run: the draft, with debug parts. */
export interface TestSessionRun {
  draft: boolean;
  debug: boolean;
}

function read(): Record<string, TestSessionRun> {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Record<string, TestSessionRun>) : {};
  } catch {
    return {};
  }
}

/**
 * Remembers that a conversation tests a draft, so continuing it in the full chat keeps running the
 * draft rather than falling back to the published version. Per browser tab, like the test itself.
 */
export function rememberTestSession(contextId: string, run: TestSessionRun): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...read(), [contextId]: run }));
  } catch {
    // Storage can be unavailable (private mode); the chat then runs what the API runs by default.
  }
}

export function testSessionRun(contextId: string): TestSessionRun | undefined {
  return read()[contextId];
}
